'use strict';

const $document = $(document);
var disableIconHeartClick = false;
const removeProductFromWishlistUrl = window.removeFromWishlistURL;
const base = require('./base');

const { get } = require('lodash');

/**
 * Updates the url for removeProductFromWishlist Modal.
 * @param {Object} data - The response Object
 */
const updateRemoveProductModel = (data) => {
    const $removeBtn = $('.remove-from-wishlist-url');
    if ($removeBtn.length) {
        $('.remove-from-wishlist-modal .js-delete-from-wishlist').attr('data-href', $removeBtn.val() + '?pid=' + data.pid);
    }
};

const WISHLIST_KEY = 'user_wishlist_product_ids';

const getWishlistFromStorage = () => {
    const data = localStorage.getItem(WISHLIST_KEY);
    return data ? JSON.parse(data) : [];
};

const saveWishlistToStorage = (wishlistArray) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlistArray));
};

const addProductToWishlistStorage = (pid) => {
    const wishlist = getWishlistFromStorage();
    if (!wishlist.includes(pid)) {
        wishlist.push(pid);
        saveWishlistToStorage(wishlist);
    }
};

const removeProductFromWishlistStorage = (pid) => {
    let wishlist = getWishlistFromStorage();
    wishlist = wishlist.filter((id) => id !== pid);
    saveWishlistToStorage(wishlist);
};

const markWishlistIconsFromLocalStorage = (pid = null, pageType = 'plp', isWishlistSelectionOverlay = null) => {
    const wishlist = JSON.parse(localStorage.getItem('user_wishlist_product_ids') || '[]');

    if (pageType === 'pdp' && pid) {
        const $wishlistWrapper = $('.add-to-wishlist-form .wishlist-wrapper');
        $('.add-to-wishlist-form').find('input[name="pid"]').val(pid);
        if (isWishlistSelectionOverlay) {
            const pdpID = $('.page-pdp.product-detail').data('pid');

            if (pdpID !== pid) {
                return;
            }
        }
        if (wishlist.includes(pid)) {
            $wishlistWrapper.addClass('added-to-wishlist');
        } else {
            $wishlistWrapper.removeClass('added-to-wishlist');
        }
    } else {
        $('.add-to-wishlist-form').each(function () {
            const $tile = $(this);
            let formPid = $tile.find('input[name="pid"]').val();

            if (!formPid) return;

            const $wishlistWrapper = $tile.find('.wishlist-wrapper');

            if (wishlist.includes(formPid)) {
                $wishlistWrapper.addClass('added-to-wishlist');
            } else {
                $wishlistWrapper.removeClass('added-to-wishlist');
            }
        });
    }
};

const initAddWishlistForm = () => {
    $(document).on('click', '.remove-confirmation-wishlist-modal .close', function () {
        $('.remove-confirmation-wishlist-modal').modal('hide');
    });
    $(document).on(
        'click',
        '.add-to-wishlist-form .icon-heart, .add-to-wishlist-form .minicart-add-to-wishlist, .add-to-wishlist-form .add-to-wishlist-text',
        function (e, customData) {
            const $this = $(this);
            const hasSlider = $this.attr('data-target-slider');
            if (disableIconHeartClick) {
                e.stopImmediatePropagation();
                e.preventDefault();
                return;
            }
            if (hasSlider) {
                return;
            }
            const $form = $this.closest('form');
            const isSizeOverlayOpened = base.openSizeSelectionDrawer();

            if (isSizeOverlayOpened) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return;
            }

            if ($('select.select-size').val() === '' && $('.add-to-cart-with-bookmark-wrapper').is(':visible')) {
                $('.select-size').closest('.attribute').find('.error-msg').removeClass('d-none');
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            var $addedToWishlistModal = $('.successful-add-to-wishlist-modal');
            const name = $this.data('product-name');
            const imageAlt = $this.data('product-image-alt');
            const image = $this.data('product-image-src');
            $addedToWishlistModal.find('.pdp-image-item img').attr('src', image);
            $addedToWishlistModal.find('.product-name .product').text(name);
            $addedToWishlistModal.find('.pdp-image-item img').attr('alt', imageAlt);
            const priceHtml = $this.closest('[data-pid]').find('.price').prop('outerHTML');
            const variationAttrHtml = $this.closest('.add-to-wishlist-form').find('.product-variation-attrs').html();
            $addedToWishlistModal.find('.product-price').html(priceHtml);
            $addedToWishlistModal.find('.product-attrs').html(variationAttrHtml);
            const isGuestUser = $('.guest-user').length > 0;
            const $wishlistBtn = $addedToWishlistModal.find('.view-your-wishlist[data-guest-text]');
            if ($wishlistBtn.length) {
                const wishlistBtnText = isGuestUser ? $wishlistBtn.data('guestText') : $wishlistBtn.data('loginText');
                const $wishlistSuccessEle = $('.wishlist-success-message');
                $wishlistSuccessEle.text(isGuestUser ? $wishlistSuccessEle.data('guestText') : $wishlistSuccessEle.data('loginText'));
                let btnUrl = new URL($wishlistBtn.attr('href'));
                btnUrl.searchParams.set('isLoginOverlay', $('.guest-user').length > 0 ? 'true' : 'false');
                $wishlistBtn.attr('href', btnUrl.toString());
                $wishlistBtn.text(wishlistBtnText);
            }

            // define body
            let dataObject = {};
            $.each($form.serializeArray(), function () {
                dataObject[this.name] = this.value || '';
            });
            if (get(customData, 'hasDlEvent')) {
                dataObject.hasDlEvent = true;
            }

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                data: dataObject,
                success: function (data) {
                    $form.find('.wishlist-wrapper').addClass('added-to-wishlist');
                    $form.find('.wishlist-wrapper').removeAttr('data-tracking-click-event');
                    updateRemoveProductModel(data);
                    addProductToWishlistStorage(data.pid);
                    if ($('.product-quickview').length) {
                        $form.closest('.product-quickview').find('.successful-add-to-wishlist-modal').modal('show');
                    }

                    $('body').trigger('gtm:add:event', { datalayer: get(data, 'datalayer', []) });
                    $(document).trigger('toasterWishlist:open');
                },
                error: function () {},
            });
        }
    );

    $document
        .off('click touchstart', '.add-to-wishlist-form .added-to-wishlist .icon-heart-filled:not(.js-delete-from-wishlist)')
        .on('click touchstart', '.add-to-wishlist-form .added-to-wishlist .icon-heart-filled:not(.js-delete-from-wishlist)', function () {
            let $modal = $('.remove-from-wishlist-modal').last();
            let productId = $(this).data('pid');
            if ($modal.length) {
                $modal.modal('show');
                $modal.attr('data-pid', productId);
                $('.modal-backdrop').slice(1).remove();
            }
        });

    $document.off('click', '.wishlist-size-submit').on('click', '.wishlist-size-submit', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $form = $this.closest('.notify-me-slider-wrapper').find('.wishlist-size-selection-form');

        let pid = $form.find('.custom-product-card').data('pid');
        const formDataObj = {};
        formDataObj.pid = pid;
        const formAction = $form.attr('action');

        $.ajax({
            url: formAction,
            type: 'POST',
            data: formDataObj,
            success: function (data) {
                $form.find('.wishlist-wrapper').addClass('added-to-wishlist');
                $('.wishlist-size-selection-overlay').removeClass('active slider-animate');
                $('body').removeClass('slider-open');
                $form.find('.wishlist-wrapper').removeAttr('data-tracking-click-event');
                addProductToWishlistStorage(data.pid);
                markWishlistIconsFromLocalStorage(data.pid, 'pdp', true);
            },
            error: function () {},
        });
    });
};

const initRemoveWishlistForm = () => {
    $(document).on('click', '.js-delete-from-wishlist', function (event) {
        event.preventDefault(); // Prevent the default link behavior
        event.stopImmediatePropagation();

        var $button = $(this);
        var removeUrl = $button.attr('data-href') || $button.attr('href'); // Get the remove URL
        var $modal = $('#removeFromWishlistModal');

        if (removeUrl === 'null') {
            var $input = $('.remove-from-wishlist-url');
            removeUrl = $input.attr('value') + '?pid=' + $modal.attr('data-pid');
        }

        $.ajax({
            url: removeUrl,
            type: 'GET',
            success: function (response) {
                if (response.success) {
                    $modal.modal('hide');
                    $(document).trigger('toasterWishlist:close');

                    var productId = new URL(removeUrl, window.location.origin).searchParams.get('pid');

                    var $wishlistForm = $('.add-to-wishlist-form')
                        .find('input[value="' + productId + '"]')
                        .closest('form');

                    $wishlistForm.find('.wishlist-wrapper').removeClass('added-to-wishlist');
                    $wishlistForm.find('.wishlist-wrapper').attr('data-tracking-click-event', 'add_to_wishlist');
                    $wishlistForm.attr('action', $wishlistForm.attr('action').replace('Wishlist-RemoveProduct', 'Wishlist-AddProduct'));
                    removeProductFromWishlistStorage(productId);
                    const $confirmationPopup = $('#removeConfirmationishlistModal').last();
                    if ($confirmationPopup) {
                        $confirmationPopup.modal('show');
                    }
                }
            },
            error: function () {},
        });
    });
};

const productTileRemoveWishlistForm = () => {
    $(document)
        .off(
            'click',
            '.add-to-wishlist-form .added-to-wishlist .icon-heart-filled:not(.js-delete-from-wishlist),  .add-to-wishlist-form .added-to-wishlist .remove-from-wishlist-text'
        )
        .on(
            'click',
            '.add-to-wishlist-form .added-to-wishlist .icon-heart-filled:not(.js-delete-from-wishlist),  .add-to-wishlist-form .added-to-wishlist .remove-from-wishlist-text',
            function () {
                var $wrapper = $(this).closest('.wishlist-wrapper');
                var pidVal = $wrapper.closest('form').find('input[name="pid"]').val();
                var removeUrl = `${removeProductFromWishlistUrl}?pid=${pidVal}`;

                if (removeUrl && !$(this).attr('data-target')) {
                    var productId = new URLSearchParams(removeUrl.split('?')[1]).get('pid');

                    $.get(removeUrl, function () {
                        $wrapper.removeClass('added-to-wishlist');
                        removeProductFromWishlistStorage(productId);

                        if ($('.wishlist-items-row').length) {
                            window.location.reload();
                        }
                    });
                }
            }
        );
};

const hoverWishlistForm = () => {
    $(document).on(
        'mouseenter touchstart',
        '.quickview-wrapper .product-quickview .add-to-wishlist-form.not-ready-to-order .icon-heart, .add-to-wishlist-form.right-section-wishlist.not-ready-to-order .icon-heart',
        function () {
            if (!$(this).closest('.wishlist-wrapper').hasClass('added-to-wishlist')) {
                $(this).attr('data-tooltip', 'Please select pen size');
                $(this).addClass('show-tooltip');
                disableIconHeartClick = true;
            }
        }
    );

    $(document).on(
        'mouseleave touchstart',
        '.quickview-wrapper .product-quickview .add-to-wishlist-form.not-ready-to-order .icon-heart, .add-to-wishlist-form.right-section-wishlist.not-ready-to-order .icon-heart',
        function () {
            $(this).removeClass('show-tooltip');
            disableIconHeartClick = false;
        }
    );
};

const variationUpdateWishlist = () => {
    let $body = $('body');

    $body.on('wishlist:updateModals', function (e, { pid }) {
        updateRemoveProductModel({ pid });
    });
};

module.exports = {
    methods: {
        hoverWishlistForm,
        initAddWishlistForm,
        initRemoveWishlistForm,
        productTileRemoveWishlistForm,
        markWishlistIconsFromLocalStorage,
        addProductToWishlistStorage,
        removeProductFromWishlistStorage,
        variationUpdateWishlist,
        getWishlistFromStorage,
    },
};
